
import { GameSession } from "../../../GameSession";
import { LogGroup } from "../../.././MyHelpers";
import { SpinAndHoldState } from "./SpinAndHoldState";

export class SpinAndHoldSession extends GameSession
{
	protected logGroup: LogGroup;
	public state: SpinAndHoldState = SpinAndHoldState.Idle;

    public RunsStarted: number = 0;
	public RunsPlayed: number = 0;
    public RunsRemaining: number = 0;
	public ScattersDisplayed: number = 0;
	public HoldReels: number[] = [];

	constructor(name: string) {
		super();

		this.logGroup = new LogGroup(["Session", "SpinAndHold", name]);
	}

	public Reset(): void
	{		this.RunsStarted = 0;
		this.RunsPlayed = 0;
        this.RunsRemaining = 0;
		this.ScattersDisplayed = 0;
		
		this.HoldReels = [];
	}

	public Update(newSession: SpinAndHoldSession)
	{
		this.RunsStarted = newSession.RunsStarted;
		this.RunsPlayed = newSession.RunsPlayed;
        this.RunsRemaining = newSession.RunsRemaining;
		this.ScattersDisplayed = newSession.ScattersDisplayed;
	}
}